import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useRef } from "react";
import { Badge, Heading } from "../../element";
import { CollapsableContainer } from "./CollapsableContainer";
import { CollapseButton } from "./CollapseButton";
import { useCollapse } from "./useCollapse";
import { SectionRows } from "./SectionRows";
export var CollapsableContentBlock = function(param) {
    var children = param.children, _content = param.content, badge = _content.badge, heading = _content.heading, sections = _content.sections, allowCollapse = param.rules.allowCollapse, translations = param.translations;
    var ref = useRef(null);
    var ref1 = useCollapse(allowCollapse, ref), canBeCollapsed = ref1.canBeCollapsed, isCollapsed = ref1.isCollapsed, setIsCollapsed = ref1.setIsCollapsed;
    var handleCollapseToggled = function(isNowCollapsed) {
        setIsCollapsed(isNowCollapsed);
    };
    var ref2 = translations || {
        collapseButton: {}
    }, _collapseButton = ref2.collapseButton, _showLessLabel = _collapseButton.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "" : _showLessLabel, _showMoreLabel = _collapseButton.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "" : _showMoreLabel;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(CollapsableContainer, {
                behavior: {
                    ref: ref
                },
                rules: {
                    canBeCollapsed: canBeCollapsed,
                    isCollapsed: isCollapsed
                },
                children: [
                    /*#__PURE__*/ _jsx(Badge, {
                        content: badge,
                        rules: {
                            badge: {
                                style: "orange"
                            }
                        }
                    }),
                    /*#__PURE__*/ _jsx(Heading, {
                        content: heading
                    }),
                    /*#__PURE__*/ _jsx(SectionRows, {
                        sections: sections,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CollapseButton, {
                behavior: {
                    ref: ref,
                    onCollapseToggled: handleCollapseToggled
                },
                rules: {
                    canBeCollapsed: canBeCollapsed,
                    isCollapsed: isCollapsed
                },
                labels: {
                    showLess: showLessLabel,
                    showMore: showMoreLabel
                }
            })
        ]
    });
};
